import { BrowserRouter, Switch } from 'react-router-dom'
import Rota from '../Routes/Rota'
import Home from '../Pages/Home'
import Settings from '../Pages/Settings'
import Feedbacks from '../Pages/Feedbacks'
import Login from '../Pages/Login'
import Error from '../Pages/Error'

function Routes(){
    return(
        <BrowserRouter>
            <Switch>
                <Rota exact path="/" isPrivate={ false } component={ Home } />
                <Rota exact path="/private/login" isPrivate={ false } isExceptionPrivate={ true } component={ Login } />
                <Rota exact path="/dashboard/configuracoes" isPrivate={ true } component={ Settings } />
                <Rota exact path="/dashboard/depoimentos" isPrivate={ true } component={ Feedbacks } />
                <Rota path="*" isPrivate={ false } component={ Error } />
            </Switch>
        </BrowserRouter>
    )
}

export default Routes